import { useDialog } from "@platform/store";
import { ProgramDialogTypes } from "@platform/types/dashboard.types";
import { ProgramFriendInviteDeletion } from "@platform/features/invitation";
import { ProgramPhasesQuizFormContainer } from "@platform/features/programQuiz";
import { ProgramScheduleFormContainer } from "@platform/features/programScheduling";
import { ProgramCircleParticipantsContainer } from "@platform/features/programCircle";
import {
  ProgramAddCalendarEventsContainer,
  ProgramMeetingInformationContainer,
} from "@platform/features/programScheduling";
import { AffiliationDeleteDialogContainer } from "@platform/features/affiliations/dialogs/AffiliationDeleteDialog";

export function ProgramDialogs() {
  const { activeDialog } = useDialog();

  if (
    ![
      "invitationDelete",
      "quiz",
      "scheduling",
      "circle",
      "meetingInformation",
      "addCalendarEvents",
      "affiliationDelete",
    ].includes(activeDialog || "")
  ) {
    return null;
  }

  switch (activeDialog as ProgramDialogTypes) {
    case "invitationDelete":
      return <ProgramFriendInviteDeletion />;
    case "quiz":
      return <ProgramPhasesQuizFormContainer />;
    case "scheduling":
      return <ProgramScheduleFormContainer />;
    case "circle":
      return <ProgramCircleParticipantsContainer />;
    case "addCalendarEvents":
      return <ProgramAddCalendarEventsContainer />;
    case "meetingInformation":
      return <ProgramMeetingInformationContainer />;
    case "affiliationDelete":
      return <AffiliationDeleteDialogContainer />;
    default:
      return null;
  }
}

export default ProgramDialogs;

